import { createUseStyles } from 'react-jss'
import { colors, sizes } from '../../variables.style'

export const style = {
  input: {
    height: sizes.textInputHeight,
    padding: `0 ${sizes.formElementPadding}`
  },
  inputMedium: {
    height: sizes.buttonHeight,
    padding: `0 ${sizes.formElementMediumPadding}`
  },
  message: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'left',
    columnGap: '12px',
    padding: '12px',
    '&.error': {
      color: 'var(--theme-status-error)'
    },
    '&.info': {
      color: 'var(--theme-status-info)'
    },
    '&.success': {
      color: 'var(--theme-status-success)'
    },
    '&.pending': {
      color: 'var(--theme-brand-yellow)'
    },
    '&.warning': {
      color: 'var(--theme-status-warning)'
    }
  }
}

export const useStyles = createUseStyles(style)
